import React, { useState } from "react";
import { useMsal } from "@azure/msal-react";
import { useAdministratorTach } from "../../../../context/AdministratorTachContext";
import { useFilterData } from "../../../../context/TachContext/FilterDataContext";
import ButtonStyles from "../../../../styles/components/ButtonStyles";
import {
    StyledFilterCell,
    StyledButtonFilterContainer,
} from "../../../../styles/pages/AdministratorTach/FilterTachStyles";
import GenericUtils from "../../../../utils/GenericUtils";
import DialogMessageProps from "../../../../model/DialogMessageProps";
import DialogMessage from "../../../../components/DialogMessage";
import AdminTachService from "../../../../service/Docente/AdminTachService";
import { TypeDialogMessageEnum } from "../../../../model/Enums/TypeDialogMessageEnum";
import {
    initialFilter,
    initialPagination,
} from "../../../../context/TachContext/initialFilterData";

const { BtnPrimary, BtnLink } = ButtonStyles;

interface IAction {
    handleClose: () => void;
}

const ActionGenerateTach: React.FC<IAction> = ({ handleClose }) => {
    const [dialogMessageProps, setDialogMessageProps] =
        useState<DialogMessageProps>({} as DialogMessageProps);

    const { filterGenerate, handleResetFilter } = useFilterData();
    const { getSubprocessos, getPendingProcess } = useAdministratorTach();
    const { instance } = useMsal();

    const hasSelectedProfessor =
        !!filterGenerate.professor.selectedValue.length;

    const isButtonDisabled = !hasSelectedProfessor;

    const handleCloseDialogMessage = () => {
        if (dialogMessageProps.type === TypeDialogMessageEnum.Success) {
            handleClose();
            getSubprocessos(initialFilter, initialPagination);
            getPendingProcess();
            handleResetFilter(false);
        }

        setDialogMessageProps({} as DialogMessageProps);
    };

    const handleGenerateTACH = async () => {
        const campusList = GenericUtils.formatFilterToList(
            "campus",
            "name",
            filterGenerate
        );
        const schoolList = GenericUtils.formatFilterToList(
            "school",
            "name",
            filterGenerate
        );
        const modalityList = GenericUtils.formatFilterToList(
            "modality",
            "id",
            filterGenerate
        );
        const courseList = GenericUtils.formatFilterToList(
            "course",
            "id",
            filterGenerate
        );
        const professorList = GenericUtils.formatFilterToList(
            "professor",
            "id",
            filterGenerate
        );

        const selectedValues = {
            campi: campusList,
            escolas: schoolList,
            modalidades: modalityList,
            centrosResultado: courseList,
            docentes: professorList,
        };

        const response = await AdminTachService.createProcess(
            selectedValues,
            instance
        );

        if (GenericUtils.isSuccessStatus(response)) {
            setDialogMessageProps({
                show: true,
                type: TypeDialogMessageEnum.Success,
                title: "Processo de Gerar TACH criado com sucesso!",
            });
        } else {
            setDialogMessageProps(GenericUtils.getPropsDialogError(response));
        }
    };

    const dialogMessage = dialogMessageProps.show && (
        <DialogMessage
            type={dialogMessageProps.type}
            show={dialogMessageProps.show}
            title={dialogMessageProps.title}
            text={dialogMessageProps.text}
            onClose={handleCloseDialogMessage}
        />
    );

    return (
        <>
            <StyledFilterCell>
                <StyledButtonFilterContainer
                    style={{ justifyContent: "center" }}
                >
                    <BtnLink
                        style={{
                            width: 126,
                            marginTop: 10,
                        }}
                        onClick={() => handleClose()}
                    >
                        Cancelar
                    </BtnLink>
                    <BtnPrimary
                        style={{
                            width: 126,
                            marginTop: 10,
                        }}
                        onClick={() => {
                            handleGenerateTACH();
                        }}
                        disabled={isButtonDisabled}
                    >
                        Gerar TACH
                    </BtnPrimary>
                </StyledButtonFilterContainer>
            </StyledFilterCell>
            {dialogMessage}
        </>
    );
};

export default ActionGenerateTach;
